module.exports = __webpack_public_path__ + "footer-logo-ig-en.png?ec7498931de24db075b93ef6c316f0b6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-logo-ig-en.png
// module id = 939
// module chunks = 0